import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { AccountAppDTO } from "../apps/AccountApp";

const PATH = "account-apps";

@Injectable({
  providedIn: "root",
})
export class AccountAppHandlerService {
  constructor(private apiService: ApiService) {}

  accountAppsGet(
    masterAccountID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.apiService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  accountAppGet(masterAccountID: number, accountAppID: number) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${accountAppID}`);
  }

  accountAppPost(masterAccountID: number, accountAppDTO: AccountAppDTO) {
    return this.apiService.post(`${PATH}/${masterAccountID}`, accountAppDTO);
  }

  accountAppPut(
    masterAccountID: number,
    accountAppID: number,
    accountAppDTO: AccountAppDTO,
  ) {
    return this.apiService.put(
      `${PATH}/${masterAccountID}/${accountAppID}`,
      accountAppDTO,
    );
  }

  accountAppDelete(masterAccountID: number, accountAppID: number) {
    return this.apiService.delete(`${PATH}/${masterAccountID}/${accountAppID}`);
  }

  getStats(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      start?: string;
      end?: string;
      group?: string;
      account_apps?: any;
      forExport?: boolean;
    }
  ) {

    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/stats`, {
        params: queryParams,
        responseType: queryParams!.forExport ? 'blob' as 'xlsx' : 'json'
      }
    );
  }

}
